/* eslint-disable camelcase */
/* eslint-disable react/no-array-index-key */
import PrimaryButton from '@components/atoms/buttons/PrimaryButton';
import Star from '@components/atoms/icons/Star';
import BREAKPOINTS from '@lib/constants/breakpoints';
import { customLink, linkResolver } from '@lib/data/prismic/helpers';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import React, { useState } from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import AmpWrap from '@components/atoms/amp/AmpWrap';
import { useAmp } from 'next/amp';
import Link from 'next/link';
import COLORS from '@lib/constants/colors';

const Wrapper = styled.div`
  border: 1px solid #eeeeee;
  border-radius: 9px;
  background: #ffffff;
  box-shadow: 0 10px 40px rgb(169 177 200 / 20%);
  padding: 25px;
  margin-bottom: 30px;

  .reviews__headline {
    margin-bottom: 20px;
  }

  .flex {
    flex: 1;
  }

  .hide {
    display: none;
  }

  .reviews__topline {
    display: grid;
    align-items: center;
    grid-gap: 20px;
    grid-template-columns: 1fr 3fr;
  }

  .reviews__headline a {
    display: inline-block;

    button {
      margin: 0;
      padding: 16px 40px 16px;
      text-transform: uppercase;
    }
  }

  .reviews__stars svg {
    margin-right: 3px;
  }

  .reviews__headline .display-flex.middle {
    grid-gap: 30px;
  }

  .reviews__fiximg {
    flex: 1;
  }

  .display-flex {
    display: flex;
  }

  .reviews__image img {
    width: 140px;
    border-radius: 4px;
  }

  .display-flex.middle {
    align-items: center;
    justify-content: center;
  }

  .reviews__fixtitle {
    line-height: 35px;

    p {
      margin: 0;
    }

    h4 {
      margin: 0;
    }
  }

  .reviews__headline h4 {
    margin: 0 0 8px;
    font-size: 20px;
    line-height: 25px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .reviews__stars strong {
    vertical-align: 0;
    margin-right: 6px;
    font-size: 21px;
  }

  .reviews__card .display-flex.--secondary .flex {
    border: 1px solid rgba(218, 232, 247, 1);
    font-size: 13px;
    line-height: 17px;
    border-radius: 7px;
    padding: 14px;
  }

  .reviews__info .display-flex {
    height: 100%;
    text-align: center;
    grid-gap: 8px;
  }

  .reviews__info p {
    margin: 0;
    font-size: 13px;
    line-height: 17px;
  }

  .reviews__info strong {
    margin-bottom: 7px;
    font-size: 14px;
    display: block;
  }

  .reviews__extra {
    margin-top: 25px;
  }

  ul.accordion {
    background: transparent;
    margin: 0;
    padding: 0;
    font-size: 17px;
    line-height: 30px;
    margin-left: 0;
    list-style-type: none;
  }

  .reviews ul li {
    margin-bottom: 0;
    padding: 0;
  }

  li {
    font-size: inherit;
  }

  ul.accordion li:last-child,
  amp-accordion section:last-child {
    .accordion-content {
      border-bottom: none;
      border-top: 1px solid #eeeeee;
    }

    .accordion-title {
      border: none;
    }
  }

  .accordion-item:first-child > :first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .accordion-title {
    font-size: 15px;
    font-weight: bold;
    padding: 13px 0;
  }

  .accordion-content {
    border: none;
    background-color: #ffffff;
    color: #0a0a0a;
    padding: 15px 0 25px;
    border-bottom: 1px solid #eeeeee;
  }

  .accordion-content ul.checklist {
    padding-left: 17px;
  }

  .accordion-content ul {
    font-size: 15px;
    line-height: 25px;
    margin-bottom: 0;
    margin-top: 0;
  }

  .accordion li {
    margin: 0;
    padding: 0;
  }

  .accordion-content ul li {
    line-height: 20px;
    padding: 0;
    margin-bottom: 10px;
  }

  .accordion-content p {
    font-size: 15px;
    line-height: 24px;
    margin: 0 0 16px;
  }

  .accordion-content p:last-child {
    margin: 0 0 0;
  }

  ul.accordion li.accordion-item {
    margin-bottom: 0;
  }

  .reviews ul li a {
  }

  .accordion-title {
    font-size: 15px;
    padding: 13px 0;
    border: none;
    border-bottom: 1px solid #eeeeee;
    font-weight: bold;
    position: relative;
    display: block;
    line-height: 1;
  }

  .accordion-title::before {
    position: absolute;
    top: 50%;
    right: 11px;
    margin-top: -11px;
    content: '+';
    font-size: 22px;
    font-weight: normal;
  }

  .is-active > .accordion-title::before,
  amp-accordion section[expanded] .accordion-title::before {
    content: '-';
  }

  :last-child > .accordion-content:last-child {
    border-bottom: none;
    border-top: 1px solid #eeeeee;
  }

  .accordion-title:last-child {
    border-bottom: none;
  }

  .help-review {
    display: block;
    font-size: 11px;
    color: #888888;
    margin-top: 5px;
    line-height: 15px;
    margin-left: 4px;
  }

  .reviews__stars {
    display: flex;
    align-items: center;
  }

  @media screen and (max-width: ${BREAKPOINTS.medium}) {
    .reviews__headline .display-flex.middle {
      flex-wrap: wrap;
    }
    .reviews__headline a {
      display: block;
      width: 100%;
    }

    .reviews__stars {
      flex-wrap: wrap;
    }

    .help-review {
      margin: 0;
    }

    .reviews__info .display-flex {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
  }

  .reviews__extra header {
    background-color: transparent;
    color: ${COLORS.pink};
  }
`;

const ReviewSlice = ({
  slice,
}: {
  slice: {
    primary: {
      name: string;
      rating: number;
      logo: {
        dimensions?: {
          width: number;
          height: number;
        };
        alt?: string;
        copyright?: string;
        url?: string;
      };
      cta: string;
      cta_link: any;
      info_name_1: string;
      info_value_1: string;
      info_name_2: string;
      info_value_2: string;
      info_name_3: string;
      info_value_3: string;
      info_name_4: string;
      info_value_4: string;
    };
    items: {
      accordion_title: string;
      accordion_content: RichTextBlock[];
    }[];
    id: string;
    slice_type: string;
    slice_label: any;
  };
}) => {
  const [state, setState] = useState<null | number>(null);

  const isAmp = useAmp();

  return (
    <Wrapper
      className="reviews"
      itemScope
      itemType="https://schema.org/Product"
    >
      <div className="reviews__headline">
        <div className="display-flex middle">
          <div className="flex">
            <div className="reviews__topline">
              <div className="reviews__image">
                <AmpWrap
                  ampOnly={
                    <amp-img
                      alt={slice.primary.logo.alt}
                      src={slice.primary.logo.url}
                      width={slice.primary.logo?.dimensions?.width}
                      height={slice.primary.logo?.dimensions?.height}
                      layout="responsive"
                    />
                  }
                  nonAmp={
                    <>
                      {slice.primary.logo.url && (
                        <Image
                          alt={slice.primary.logo.alt}
                          src={slice.primary.logo.url}
                          layout="intrinsic"
                          width={slice.primary.logo?.dimensions?.width}
                          height={slice.primary.logo?.dimensions?.height}
                        />
                      )}
                    </>
                  }
                />
              </div>
              <div className="reviews__fiximg">
                <div className="reviews__fixtitle">
                  <h4 itemProp="name">{slice.primary.name}</h4>
                  <div
                    className="reviews__stars"
                    itemProp="aggregateRating"
                    itemScope
                    itemType="http://schema.org/AggregateRating"
                  >
                    <strong itemProp="ratingValue">
                      {slice.primary.rating.toFixed(1)}
                    </strong>
                    <p itemProp="ratingCount" className="hide fk">
                      500
                    </p>
                    {[1, 2, 3, 4, 5].map((i) => (
                      <Star
                        key={i}
                        size={18}
                        selected={i / slice.primary.rating < 1.2}
                        activeColor="#fcd42d"
                        half={
                          i / slice.primary.rating > 1 &&
                          i / slice.primary.rating < 1.2
                        }
                      />
                    ))}

                    <div className="help-review">
                      <span>Avaliação Luna</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Link passHref href={linkResolver(slice.primary.cta_link)}>
            <a
              className="button green btn-desktop"
              itemProp="url"
              rel="noopener noreferrer"
            >
              <PrimaryButton pink isBlock>
                {slice.primary.cta}
              </PrimaryButton>
            </a>
          </Link>
        </div>
      </div>
      <div className="reviews__card">
        <div className="display-flex --primary">
          <div className="reviews__info flex">
            <div className="display-flex --secondary">
              {[
                {
                  title: slice.primary.info_name_1,
                  value: slice.primary.info_value_1,
                },
                {
                  title: slice.primary.info_name_2,
                  value: slice.primary.info_value_2,
                },
                {
                  title: slice.primary.info_name_3,
                  value: slice.primary.info_value_3,
                },
                {
                  title: slice.primary.info_name_4,
                  value: slice.primary.info_value_4,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex"
                  itemProp="additionalProperty"
                  itemScope
                  itemType="https://schema.org/PropertyValue"
                >
                  <strong itemProp="name">{item.title}</strong>
                  <p itemProp="value">{item.value}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="reviews__extra">
        {!!slice.items.length && (
          <AmpWrap
            ampOnly={
              <amp-accordion>
                {slice.items.map((item, index) => (
                  <section key={index}>
                    <header className="accordion-title">
                      <span itemProp="name">{item.accordion_title}</span>
                    </header>
                    <div className="accordion-content">
                      <RichText
                        render={item.accordion_content}
                        linkResolver={linkResolver}
                        serializeHyperlink={customLink}
                      />
                    </div>
                  </section>
                ))}
              </amp-accordion>
            }
            nonAmp={
              <ul className="accordion">
                {slice.items.map((item, index) => (
                  <li
                    key={index}
                    className={`accordion-item ${
                      state === index || isAmp ? 'is-active' : ''
                    }`}
                    itemProp="additionalProperty"
                    itemScope
                    itemType="https://schema.org/PropertyValue"
                  >
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setState(state === index ? null : index);
                      }}
                      href="#"
                      className="accordion-title"
                    >
                      <span itemProp="name">{item.accordion_title}</span>
                    </a>
                    <div
                      className="accordion-content"
                      style={{
                        display: state === index || isAmp ? 'block' : 'none',
                      }}
                    >
                      <RichText
                        render={item.accordion_content}
                        linkResolver={linkResolver}
                        serializeHyperlink={customLink}
                      />
                    </div>
                  </li>
                ))}
              </ul>
            }
          />
        )}
      </div>
    </Wrapper>
  );
};

export default ReviewSlice;
